/**
 * ユーザ一括登録
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    InputBase,
    Typography,
    Button,
    InputLabel
} from '@material-ui/core';
import { dictionary, clientsInfo } from 'mdoc/admin/axios'
import { getFilePath, userAllUpload } from 'mdoc/admin/axios/user'
import Toast from 'mdoc/utils/toast';
import Dialog from 'mdoc/utils/myDialog';
import CustomizedTable from 'mdoc/utils/table'
import eventProxy from 'mdoc/utils/eventProxy'

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        },
        space: {
            height: theme.spacing.unit
        },
        minWidth: '50%'
    },
    bootstrapInput: {
        // borderRadius: 4,
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    fileInput: {
        display: 'none',
    },
    cusButton: {
        borderRadius: 0,
        boxShadow: 'none',
        backgroundColor: '#CED4DA',
        color: '#ffffff',
        maxWidth: '50%'
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px',
    },
    tableContainer: {
        height: '200px',
    },
    error: {
        backgroundColor: 'red'
    },
    drop: {
        width: '298px'
    },
    title: {
        marginLeft: '-20px'
    }
});

class User_AllEdit extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        // data: [{'title':'件数','number':3},{'title':'エラー件数','number':1}],
        resultData: [],
        detailData: [],
        noPage: true,
        // loading: false,
        dictWord: {
            'csv_file_upload': '',
            'user_multiple_registration': '',
            'file_select': '',
            'registration_format': '',
            'cancel': '',
            'upload': '',
            'close': '',
            'upload_filename': '',
            'upload_result': '',
            'count': '',
            'failed_count': '',
            'upload_detail': '',
            'dimension_no': '',
            'judge': '',
            'error_detail': '',
            'user_name': '',
            'user_id': '',
            'msg_error_not_select_file': '',
            'msg_error_upload_file_type_invalid': '',
            'confirmation': '',
        },
        dialogOpen: false,
        fileList: [],
        fileName: '',
        uploadFileName: '',
        errorCount: '',
        count: '',
        uploadCount: '',
    };
    componentWillMount() {
        this.start(this.state);
    }
    start = (state) => {
        // this.setState({loading: true});
        let dict = {}
        dictionary(state.dictWord).then(res => {
            res.map(val => {
                dict[val.dictKey] = val.dictValue;
                return val;
            })
            this.setState({
                dictWord: dict,
            })
        })
    }


    handleChange = (filed) => event => {
        this.setState({
            [filed]: Object.assign(this.state[filed], { value: event.target.value })
        });
    };
    //登録フォーマット
    fileFormat = () => {
        let dicWord = this.state.dictWord.user_multiple_registration
        getFilePath(dicWord + '.csv').then(res => {
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    onFileDrop(event) {
        let me = this;
        let files = event.target.files || [];
        if (files.length < 1) return;
        let file = files[0];
        let name = file.name;
        let type = name.substr(name.lastIndexOf(".")).toLowerCase();//获得文件后缀名
        if (type.indexOf('csv') < 0) {
            Toast.error(me.state.dictWord['msg_error_upload_file_type_invalid']);
            return;
        }
        this.setState({
            fileName: name,
            fileList: files
        });
    }
    fileButton() {
        let fileInput = document.getElementById('button-file');
        fileInput.value = [];
    }
    //アップロード
    fileUpload = () => {
        let fileList = this.state.fileList;
        if (fileList.length < 1) {
            Toast.info(this.state.dictWord['msg_error_not_select_file'])
        } else {
            let data = new FormData();
            for (let key in fileList) {
                let item = fileList[key];
                if (typeof item === 'object') data.append("upfile", item);
            }
            userAllUpload(data).then(res => {
                this.setState({
                    dialogOpen: true,
                    uploadFileName: res.results.fileUuid,
                    errorCount: res.results.errorCount,
                    detailData: res.results.uploadErrorDetails,
                    uploadCount: res.results.uploadCount,
                });
                clientsInfo().then(data => {
                    eventProxy.trigger('uploadFiles', data);
                }).catch(function (err) {
                    Toast.error(err);
                })
            }).catch(function (error) {
                Toast.error(error);
            })
        }
    }
    dialogHandleOff = () => {
        this.setState({
            dialogEorrorOpen: false
        })
    }
    dialogHandleClose = () => {
        let errorCount = this.state.errorCount
        if (errorCount > 0) {
            this.setState({
                dialogOpen: false
            })
        } else {
            this.props.history.push('/admin/management/user');
        }
    }
    render() {
        const { classes } = this.props;
        const { dictWord } = this.state;
        const columnsDetail = [
            {
                title: this.state.dictWord.dimension_no,
                dataIndex: 'numberSeq',
            },
            {
                title: this.state.dictWord.user_id,
                dataIndex: 'userCode',
            },
            {
                title: this.state.dictWord.user_name,
                dataIndex: 'userName',
            },
            {
                title: this.state.dictWord.judge,
                dataIndex: 'determineResult',
                render: (text, record) => {
                    if (record['determineResult'] === 'NG') {
                        return <span className={classes.error}>NG</span>
                    } else {
                        return <span>OK</span>
                    }
                }
            },
            {
                title: this.state.dictWord.error_detail,
                dataIndex: 'errorContent',
            },
        ];
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />

                <Grid item xs={12} md={12}>
                    <Button variant="contained" color="primary" onClick={this.fileFormat} className={classes.margin}>
                        {this.state.dictWord.registration_format}
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.fileUpload} className={classes.margin}>
                        {dictWord.upload}
                    </Button>
                    <Button href={'/admin.html#/admin/management/user'} variant="contained" color="primary" className={classes.margin}>
                        {dictWord.cancel}
                    </Button>
                </Grid>
                <Typography variant="h5" gutterBottom className={classes.margin}>
                    {dictWord.csv_file_upload}
                </Typography>
                <Grid container className={classes.margin} style={{ width: '100%', whiteSpace: 'nowrap', }}>
                    <Grid item xs={12} md={3} style={{ maxWidth: '70%' }}>
                        <input
                            accept=".csv"
                            className={classes.fileInput}
                            id="button-file"
                            type="file"
                            onChange={this.onFileDrop.bind(this)}
                        />
                        <label htmlFor="button-file">
                            <InputBase value={this.state.fileName} readOnly classes={{ root: classes.bootstrapRoot, input: classes.bootstrapSelect, }} />
                            <Button variant="contained" component="span" color="default" className={classes.cusButton} onClick={this.fileButton.bind(this)}>
                                {dictWord.file_select}
                            </Button>
                        </label>
                    </Grid>
                    {/* <Grid item xs={12} md={3} style={{ marginLeft: '3%', maxWidth: '25%' }}>
                        <Button variant="contained" color="primary" onClick={this.fileFormat}>
                            {this.state.dictWord.registration_format}
                        </Button>
                    </Grid> */}
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        maxWidth: 'lg',
                    }}
                    content={
                        <div>
                            <Typography variant="h5" style={{ fontSize: '12px' }}>
                                {this.state.dictWord.upload_filename}
                            </Typography>
                            <p>{this.state.uploadFileName}</p>
                            <Grid container className={classes.margin}>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h5" style={{ fontSize: '12px' }}>
                                        {this.state.dictWord.upload_result}
                                    </Typography>
                                    <Grid container className={classes.margin}>
                                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                                            <InputLabel shrink htmlFor="">
                                                {this.state.dictWord.count}
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <span>{this.state.uploadCount}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid container className={classes.margin}>
                                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                                            <InputLabel shrink htmlFor="">
                                                {this.state.dictWord.failed_count}
                                            </InputLabel>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <span>{this.state.errorCount}</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h5" style={{ fontSize: '12px' }}>
                                        {this.state.dictWord.upload_detail}
                                    </Typography>
                                    <Typography component="div" className={classes.tableContainer}>
                                        <CustomizedTable
                                            data={this.state.detailData}
                                            noPage={this.state.noPage}
                                            columns={columnsDetail}
                                        />
                                    </Typography>
                                </Grid>
                            </div>
                        </div>
                    }
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

User_AllEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(User_AllEdit);
// export default withStyles(styles)(connect(mapStateToPorps)(User_AllEdit));